import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Get authentication headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

/**
 * Get total admin count
 */
export const getAdminCount = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/admin/management/admins/count`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Get admin count error:', error);
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch admin count'
    };
  }
};

/**
 * Get all admins with details
 */
export const getAllAdmins = async (includeInactive = false) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/admin/management/admins`,
      {
        headers: getAuthHeaders(),
        params: { include_inactive: includeInactive }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Get admins error:', error);
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch admins'
    };
  }
};

/**
 * Delete (deactivate) an admin
 */
export const deleteAdmin = async (adminId) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/admin/management/admins/${adminId}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Delete admin error:', error);
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to delete admin'
    };
  }
};

/**
 * Reset admin password
 */
export const resetAdminPassword = async (adminId, newPassword) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/admin/management/admins/${adminId}/reset-password`,
      { admin_id: adminId, new_password: newPassword },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Reset password error:', error);
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to reset password'
    };
  }
};

/**
 * Get admin activity history
 */
export const getAdminActivity = async (adminId, month = null, year = null, limit = 100) => {
  try {
    const params = { limit };
    if (month) params.month = month;
    if (year) params.year = year;

    const response = await axios.get(
      `${API_URL}/api/admin/management/admins/${adminId}/activity`,
      {
        headers: getAuthHeaders(),
        params
      }
    );
    return response.data;
  } catch (error) {
    console.error('Get admin activity error:', error);
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch activity'
    };
  }
};

/**
 * Get admin productivity stats
 */
export const getAdminProductivity = async (adminId, days = 30) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/admin/management/admins/${adminId}/productivity`,
      {
        headers: getAuthHeaders(),
        params: { days }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Get admin productivity error:', error);
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch productivity stats'
    };
  }
};

/**
 * Get productivity overview for all admins
 */
export const getAllAdminsProductivity = async (days = 30) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/admin/management/productivity/overview`,
      {
        headers: getAuthHeaders(),
        params: { days }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Get all admins productivity error:', error);
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch productivity overview'
    };
  }
};
